import { Button } from '@thg-commerce/gravity-elements'
import { Grid, GridItem } from '@thg-commerce/gravity-system'
import {
  css,
  Margin,
  margin,
  mq,
  spacing,
  styled,
  Text,
  TextStyling,
} from '@thg-commerce/gravity-theme'

export const marginRightDesktop = css<{
  showInlineFeatureScores?: boolean
}>`
  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    ${(props) =>
      props.showInlineFeatureScores && `margin-right: ${spacing(10)}`}
  }
`

export const CustomerReviewSingle = styled(Grid)<{
  margin: Margin
  paddingTop?: number
}>`
  padding-top: ${(props) => spacing(props.paddingTop || 4)};
  grid-gap: 0;
  ${(props) => margin(props.margin)};
`

export const ReviewTitle = styled(GridItem)<{
  showInlineFeatureScores?: boolean
  textStyle?: TextStyling
}>`
  ${(props) => Text(props.textStyle?.entry ?? 'large1', 'alternate')};
  ${marginRightDesktop}
  margin-bottom: ${spacing(2)};
`

export const ReviewRating = styled(GridItem)<{
  showInlineFeatureScores?: boolean
}>`
  ${marginRightDesktop}
  align-items: center;
  margin-bottom: ${spacing(2)};
  color: ${(props) => props.theme.colors.palette.brand.base};
`

export const FeatureRating = styled(GridItem)<{
  showInlineFeatureScores?: boolean
}>`
  margin: 0 0 ${spacing(3)} 0;

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    ${(props) =>
      props.showInlineFeatureScores &&
      `margin-bottom: ${spacing(6.5)};
       margin-top: ${spacing(6.5)};`}
  }
`

export const ReviewExcerpt = styled(GridItem)<{
  showInlineFeatureScores?: boolean
}>`
  ${Text('bodyText', 'default')};
  ${marginRightDesktop}
  display: block;
  margin-bottom: ${spacing(2)};
`

export const ReviewFooter = styled(GridItem)<{
  showInlineFeatureScores?: boolean
}>`
  ${marginRightDesktop}
  display: flex;
  align-items: center;
  margin-bottom: ${spacing(3)};
  flex-wrap: wrap;
`

export const ReviewFooterDateAndName = styled.div<{
  textStyle?: TextStyling
}>`
  ${(props) =>
    Text(
      props.textStyle?.entry || 'bodyText',
      props.textStyle?.style || 'alternate',
    )};
  padding-right: ${spacing(1)};
`

export const ReviewFooterVerified = styled.div<{
  textStyle?: TextStyling
}>`
  ${(props) =>
    Text(
      props.textStyle?.entry || 'bodyText',
      props.textStyle?.style || 'alternate',
    )};
  white-space: nowrap;
  color: ${(props) => props.theme.colors.success.base};

  &:before {
    content: '**';
  }

  &:after {
    content: '**';
  }
`

export const VotingArea = styled(GridItem)<{
  showInlineFeatureScores?: boolean
}>`
  ${marginRightDesktop}
  display: block;
  margin-bottom: ${spacing(3)};
`

export const VotingAreaQuestion = styled.div`
  ${Text('bodyText', 'default')};
  margin-bottom: ${spacing(1.5)};
`

export const ButtonsWrapper = styled.div`
  display: inline-flex;
  flex-direction: row;
`

export const VoteYesButton = styled(Button)`
  align-items: center;
  margin-right: ${spacing(1)};
`

export const VoteNoButton = styled(Button)`
  align-items: center;
`

const reviewReportProperty = css<{
  textStyle?: TextStyling
}>`
  ${(props) =>
    Text(
      props.textStyle?.entry || 'bodyText',
      props.textStyle?.style || 'default',
    )};
  color: ${(props) => props.textStyle?.textColor || 'inherit'};
`

export const ReviewReport = styled(Button)`
  align-items: center;
  cursor: pointer;
  border: 2px solid transparent;
  ${reviewReportProperty}

  &:hover {
    border: 2px solid transparent;
    ${reviewReportProperty}
  }

  &:focus,
  &:focus-within,
  &:active {
    ${reviewReportProperty}
  }
`

export const VoteIcon = styled.div`
  align-items: center;
  margin-right: ${spacing(1)};
`

export const ErrorText = styled.p`
  ${Text('medium1', 'default')};
  margin-bottom: ${spacing(2)};
`

export const PlatformMessageContainer = styled.div<{
  showMessage: boolean
}>`
  display: none;

  ${(props) =>
    props.showMessage === true &&
    `
    display: inline-block;
    margin-top: ${spacing(2)};
  `}
`

export const ReviewVotingButtonsContainer = styled(GridItem)<{
  showInlineFeatureScores?: boolean
}>`
  ${marginRightDesktop}
  display: inline;
  border-bottom: 1px solid ${(props) => props.theme.colors.palette.greys.light};
  padding-bottom: ${spacing(3.5)};
`
